import colors from "core/resources/theme/colors";
import { AiFillTool, AiOutlineCheck } from "react-icons/ai";
import { RiAlertFill } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { Box, SimpleGrid } from "@chakra-ui/layout";
import ProximasManutencoes from "./components/ProximasManutencoes";
import { useDashboardManutencao } from "core/features/manutencao/hooks/useDashboardManutencoes";
import { FiltroManutencao } from "./../ListagemManutencaoTable/hooks/useFiltroManutencao";
import { StatusManutencaoEnum } from "features/manutencao/typings";
import Card1Horizontal from "components/Cards/Card1Horizontal";

interface DashboardManutecaoProps {
  filtro: FiltroManutencao;
  onFiltroStatus?: (props: {
    statusId?: StatusManutencaoEnum;
    emAtraso?: "true";
  }) => any;
}

function DashboardManutencao({
  filtro,
  onFiltroStatus,
}: DashboardManutecaoProps) {
  const { data, isLoading: loading } = useDashboardManutencao({
    ...filtro,
  });

  return (
    <SimpleGrid
      templateRows="repeat(2, 1fr)"
      templateColumns="repeat(4, 1fr)"
      gap="16px"
      mb="32px"
      mt="40px"
    >
      <Box gridRow="span 1" gridColumn="span 1">
        <Card1Horizontal
          icon={<AiFillTool fontSize="24px" color={colors.blue300} />}
          color={colors.blue}
          bg={colors.blue100}
          description={data?.equipamentos === 1 ? "Patrimônio" : "Patrimônios"}
          descriptionFontSize={16}
          title={`${data?.equipamentos || 0}`}
          loading={loading}
        />
      </Box>

      <Box gridRow="span 1" gridColumn="span 1">
        <Card1Horizontal
          icon={<AiOutlineCheck fontSize="24px" color={colors.green} />}
          color={colors.blue}
          bg={colors.green100}
          description="Concluídas"
          descriptionFontSize={16}
          selected={filtro?.statusId === StatusManutencaoEnum.Concluida}
          title={`${data?.concluidas || 0}`}
          loading={loading}
          onClick={() =>
            onFiltroStatus?.({
              statusId: StatusManutencaoEnum.Concluida,
              emAtraso: undefined,
            })
          }
        />
      </Box>

      <Box gridRow="span 2" gridColumn="span 2">
        <ProximasManutencoes data={data || undefined} />
      </Box>

      <Box gridRow="span 1" gridColumn="span 1">
        <Card1Horizontal
          icon={<RiAlertFill fontSize="24px" color={colors.orange} />}
          color={colors.blue}
          bg={colors.orange10}
          description={"Pendentes"}
          selected={filtro?.statusId === StatusManutencaoEnum.Pendente}
          descriptionFontSize={16}
          title={`${data?.pendentes || 0}`}
          loading={loading}
          onClick={() =>
            onFiltroStatus?.({
              statusId: StatusManutencaoEnum.Pendente,
              emAtraso: undefined,
            })
          }
        />
      </Box>

      <Box gridRow="span 1" gridColumn="span 1">
        <Card1Horizontal
          icon={<MdOutlineClose fontSize="24px" color={colors.red} />}
          color={colors.blue}
          bg={colors.red100}
          description={"Em atraso"}
          selected={!!filtro?.emAtraso}
          descriptionFontSize={16}
          title={`${data?.emAtraso || 0}`}
          loading={loading}
          onClick={() =>
            onFiltroStatus?.({ statusId: undefined, emAtraso: "true" })
          }
        />
      </Box>
    </SimpleGrid>
  );
}

export default DashboardManutencao;
